export default {
      id: "uspCard-getGuaranteed-usage",
      viewBox: "0 0 200 60",
      url: __webpack_public_path__ + "sprite.svg#uspCard-getGuaranteed",
      toString: function () {
        return this.url;
      }
    }